import { Alert } from '@cast/design-system';

import { BuilderPanel } from './BuilderPanel';

export const NonRepresentableConfig = () => {
  return (
    <BuilderPanel>
      <Alert
        severity="info"
        color="info"
        testId="evictor-builder-non-representable-alert"
      >
        Builder View can&apos;t display your advanced configuration due to
        custom rules created directly via YAML. Switch to YAML to continue
        editing.
      </Alert>
    </BuilderPanel>
  );
};
